export default __webpack_public_path__ + "static/media/borne-.712ac2d4.svg";